import React, { useState, useEffect } from 'react'
import get from 'lodash/get'
import { Input, Form, Select, DatePicker, Button } from 'antd'
import { NumericFormat } from 'react-number-format'
import moment from 'moment'
import { DeleteOutlined } from '@ant-design/icons'

const TableCell = ({
  row,
  form,
  children,
  disabled,
  onUpdate,
  errorMessage,
  column = {
    format: {},
    dataIndex: '',
    editable: false,
    options: null
  },
  ...otherProps
}) => {
  const [rowValue, setRowValue] = useState('')
  useEffect(() => {
    setRowValue(get(row, column.dataIndex))
  }, [column.dataIndex, row])

  const changeRowValue = value => {
    setRowValue(value)
    if (Array.isArray(column.dataIndex)) {
      onUpdate(row, `${column.dataIndex[0]}.${column.dataIndex[1]}`, value)
    } else {
      onUpdate(row, column.dataIndex, value)
    }
  }

  return (
    <td {...otherProps}>
      {column && column.editable ? (
        <Form.Item
          style={{ margin: 0 }}
          help={errorMessage}
          validateStatus={errorMessage ? 'error' : ''}
        >
          {column.options ? (
            <Select
              data-testid={column.dataIndex}
              style={{ width: '100%' }}
              disabled={disabled}
              onChange={value => changeRowValue(value)}
              value={rowValue}
            >
              {column.options}
            </Select>
          ) : column.format === 'string' ? (
            <Input
              data-testid={column.dataIndex}
              disabled={disabled}
              value={rowValue}
              onChange={e => changeRowValue(e.target.value)}
            ></Input>
          ) : column.format === 'date' ? (
            <DatePicker
              value={
                rowValue
                  ? moment(rowValue.substring(0, 10), 'YYYY-MM-DD')
                  : null
              }
              disabled={disabled}
              // @ts-ignore
              onChange={(_, dateValue) => changeRowValue(dateValue)}
            />
          ) : column.format === 'actions' ? (
            <Button
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => changeRowValue(null)}
              danger
            />
          ) : (
            <NumericFormat
              className={'input-number'}
              data-testid={column.dataIndex}
              disabled={disabled}
              value={rowValue}
              onValueChange={values => changeRowValue(values.value)}
              {...column.format}
            />
          )}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  )
}

export default TableCell
